// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Jl","title":"Kl","nav":"Ll","flexCell":"Ml","facetLink":"Nl"};